<template>
    <div id="materChangeStoreManage">
        <el-form ref="searchForm" style="width:100%" :inline="true" :model="searchForm" :label-position="labelPosition">
            <el-form-item style="margin-bottom:15px"class="hewidth">
                <el-input clearable v-model.trim="searchForm.code" placeholder="入库编号"></el-input>
            </el-form-item>
             <el-form-item style="margin-bottom:15px"class="hewidth">
                <el-input clearable v-model.trim="searchForm.addCode" placeholder="请输入小码查询"></el-input>
            </el-form-item>
           <el-form-item style="width:150px;margin-bottom:15px" class="hewidth">
                <el-select filterable clearable :filter-method="PinyinMatch" @change="changeOperatorUser" v-model="searchForm.operatorUser" placeholder="请选择操作人">
                    <el-option v-for="(item,index) in operatorUserAllList" 
                        :label="item.staffName" 
                        :value="item.staffName" 
                        :key="index">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item style="width:30%;margin-bottom:15px">
                <el-date-picker
                    style="width: 100%;"
                    v-model="valueTime3"
                    type="daterange"
                    range-separator="-"
                    :default-time="['00:00:00', '11:59:59']"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <!-- <el-form-item class="fr">
                <el-col style="text-align:right">
                    <el-button size="medium" type="success" v-if="basicsAuth.transferLibraryAdd" @click="createOrder()">新建物料转库</el-button>
                    <el-button type="success" size="medium" @click="downLoad.exportExcel('tableId')">导出</el-button>
                    <i class="el-icon-refresh" style="font-size: 25px;cursor: pointer;margin-left: 30px;" @click="refresh()"></i>
                </el-col>
            </el-form-item> -->
        </el-form>
        <el-form ref="searchForm" style="width:100%" :inline="true" :model="searchForm" :label-position="labelPosition">
             <el-form-item style="margin-bottom:15px" class="hewidth">
                <el-select v-model="searchForm.warehouseTypeOut" placeholder="请选择转出仓库" clearable>
                    <el-option v-for="(item,index) in pickingList" 
                        :label="item.paraName" 
                        :value="item.paraCode" 
                        :key="index">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item style="margin-bottom:15px" class="hewidth">
                <el-select v-model="searchForm.warehouseTypeInput" placeholder="请选择转入仓库"  clearable>
                    <el-option v-for="(item,index) in pickingList" 
                        :label="item.paraName" 
                        :value="item.paraCode" 
                        :key="index">
                    </el-option>
                </el-select>
            </el-form-item>
            
             
            <el-form-item style="width: 50%; margin-bottom: 15px;">
                <el-button type="primary" size="medium" @click="onSubmit('searchForm')">查询</el-button>
                <el-button type="text" @click="clearFrom()" style="width: 60px;color: #169BD5;">重置</el-button>
                <el-button size="medium" type="success" v-if="basicsAuth.transferLibraryAdd" @click="createOrder()">新建转库</el-button>
                    <el-button type="success" size="medium" @click="downLoad.exportExcel('tableId')">导出</el-button>
                    <i class="el-icon-refresh" style="font-size: 25px;cursor: pointer;margin-left: 8px;" @click="refresh()"></i>
            </el-form-item>
        </el-form>
        <el-col>
            <el-card class="box-card" style="width: 100%;">
                <el-table
                    :data="returnData"
                    border
                    id="tableId"
                    :header-cell-style="{'text-align':'center'}"
                    style="width: 100%"
                    @row-click="goToDetail">
                    <el-table-column
                        align="center"
                        prop="code"
                        width="150"
                        label="转库编号">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="warehouseTypeOut"
                        label="转出仓库">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="warehouseTypeInput"
                        label="转入仓库">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="sum"
                        label="转库数量">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="memo"
                        label="备注信息">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="status"
                        label="状态">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="operatorUser"
                        label="操作人">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="createTime"
                        width="155"
                        label="提交时间">
                    </el-table-column>
                </el-table>
            </el-card>
            <!--分页-->
            <el-col :span="24" class="toolbar">
                <div class="pagination">
                    <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pages.page"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="pages.pageSize"
                        layout="total, sizes, prev, pager, next,jumper"
                        :total="pages.total">
                    </el-pagination>
                </div>
            </el-col>
        </el-col>
    </div>
</template>

<script>
    let moment = require("moment");
    import {
        transferLibraryList,
        selectParameterInfoBusiness,
        queryUser
    } from "../../api/api";
    import PinyinMatch from 'pinyin-match';
    import {getPermission} from '../../api/authRequest'
    export default {
        name: 'materChangeStoreManage',
        components: {
        },
        data () {
            return {
                orderId:'',
                valueTime3:[],
                //分页变量
                pages:{
                    total: 0,
                    page: 1,
                    pageSize: 10,
                },
                pickingList:[],
                labelPosition:'left',
                searchForm:{
                    code:'',               //出入库编号
                    status:'YQR',         
                    operatorUser:'',       //操作人
                    attribute1:'',         //开始时间
                    attribute2:'',         //结束时间
                    warehouseTypeOut:'',   //转出仓库类型
                    warehouseTypeInput:'', //转入仓库类型
                    addCode:""
                },
                returnData: [],
                copy:[],
                operatorUserAllList:[],
                basicsAuth:{
                    transferLibraryAdd:false
                }
            }
        },
        mounted () {
            this.basicsAuth.transferLibraryAdd = getPermission('/api/transferLibrary/transferLibraryAdd');
        },
        created:function(){
            this.$destroy();
            this.getTransferLibraryList()
            this.getSelectParameterInfoBusiness();
            this.getOperatorUserAllList();
        },
        methods: {
            //强制刷新
            changeOperatorUser(e){
                console.log(e);
                this.searchForm.operatorUser = e;
                this.$forceUpdate();
            },
            PinyinMatch(val){
                if(val && val.length > 0){
                    let result = [];
                    this.copy.forEach(i => {
                        let m = PinyinMatch.match(i.staffName,val);
                        if(m) {
                            result.push(i);
                        }
                    })
                    this.searchForm.operatorUser = val;
                    this.operatorUserAllList = result;
                }else{
                    this.operatorUserAllList = this.copy;
                    this.searchForm.operatorUser = "";
                }
            },
            getOperatorUserAllList(){
                queryUser({type:2}).then(res => {     
                    if (res.data.status==100) {
                        this.operatorUserAllList = res.data.results;
                        this.copy = Object.assign(this.operatorUserAllList); //保留数据源
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //获取出入仓库列表
            getSelectParameterInfoBusiness(){
                let para={
                    paraType: 'warehouse_type'
                }
                selectParameterInfoBusiness(para).then(res => {          
                    if (res.data.status==100) {            
                        this.pickingList = res.data.results.list          
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            clearFrom(){
                this.searchForm = {}
                this.valueTime3 = []
            },
            //获取采购管理列表
            getTransferLibraryList(){
                let para={
                    code: this.searchForm.code,
                    status: this.searchForm.status,
                    operatorUser: this.searchForm.operatorUser,
                    attribute1: this.searchForm.attribute1,
                    attribute2: this.searchForm.attribute2,     
                    warehouseTypeOut: this.searchForm.warehouseTypeOut,
                    warehouseTypeInput: this.searchForm.warehouseTypeInput,
                    startRow: this.pages.page,
                    pageSize: this.pages.pageSize,
                    sn: this.searchForm.addCode
                }
                transferLibraryList(para).then(res => {          
                    if (res.data.status==100) { 
                        this.returnData = res.data.results.list
                        this.returnData.forEach((item,index)=>{
                            item.createTime = this.filters.formatDate(item.createTime)
                        })
                        this.pages.total = res.data.results.total
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //金额转化函数
            addCommas:function(row,column){
                var num = row[column.property];
                var b= num.toString().replace(/\$|\,/g,'');
                if(isNaN(num))
                    num = "0";
                var sign = (num == (num = Math.abs(num)));
                num = Math.floor(num*100+0.50000000001);
                var cents = num%100;
                num = Math.floor(num/100).toString();
                if(cents<10)
                cents = "0" + cents;
                for (var i = 0; i < Math.floor((num.length-(1+i))/3); i++)
                num = num.substring(0,num.length-(4*i+3))+','+
                num.substring(num.length-(4*i+3));
                return (((sign)?'':'-') + num + '.' + cents);
            },
            //时间转化函数
            dateFormat:function(row, column) {
                var date = row[column.property];
                if (date == undefined) {
                    return "";
                }
                return moment(date).format("YYYY-MM-DD");
            },
            handleSizeChange(val) {
                //console.log(val)
                this.pages.pageSize = val
                this.getTransferLibraryList()
            },
            handleCurrentChange(Page) {
                //console.log(Page)
                this.pages.page = Page
                this.getTransferLibraryList()
            },
            //进入详情页面
            goToDetail(row) {
                this.$router.push({
                    path:'/materChangeStoreInfo',
                    query:{
                      orderId:row.id
                    }
                })
            },
            //新建采购订单
            createOrder() {
                this.$router.push({
                    path:'/newMaterChangeStore',
                })
            },
            refresh() {
                this.searchForm = {}
                this.getTransferLibraryList()
            },
            onSubmit(formname) {
                this.$refs[formname].validate((valid) => {
                    if (valid) {
                        if(this.valueTime3 == null){
                            this.searchForm.attribute1 = ''
                            this.searchForm.attribute2 = ''
                        }else if (this.valueTime3.length == 0) {
                            this.searchForm.attribute1 = ''
                            this.searchForm.attribute2 = ''
                        }else{
                            this.searchForm.attribute1 = this.moment(this.valueTime3[0]).format("YYYY-MM-DD");
                            this.searchForm.attribute2 = this.moment(this.valueTime3[1]).format("YYYY-MM-DD");
                        }
                        this.getTransferLibraryList()
                  
                    } else {
                        return false;
                    }
                });
            }
        },
        computed: {
        },
        watch: {
        }
    }
</script>

<style type="text/css" lang="scss" scoped>
    #materChangeStoreManage{font-size: 14px;
        .headerT{margin:10px 0 15px 0;}
        tr.el-table__row{cursor: pointer;}
        input.el-input__inner{padding-right:25px; }
    }
    .hewidth {
        width: 18% !important;
      }
</style>



// WEBPACK FOOTER //
// materChangeStoreManage.vue?8f36e460